<template>
  <layout-pondlogs containerType="card">
    <template slot="title">{{ $t("Comn_battery") }}</template>
    <template slot="header">
      <layout-toolbar>
        <el-col :span="4.5">
          <er-input
            inputType="search"
            v-model="filters[0].value"
            size="mini"
            suffix-icon="el-icon-search"
            :placeholder="$t('Pond_search_pond')"
          ></er-input>
        </el-col>
        <span class="el-col el-col-1">
          <er-button
            btnType="refresh"
            :showIcon="true"
            type="text"
            size="mini"
            @click="initComponent"
          />
        </span>
      </layout-toolbar>
    </template>
    <el-row slot="pondlogs-default-layout-main">
      <el-row>
        <er-data-tables
          :table-data="tableDataArr"
          v-loading="loading"
          :filters="filters"
          :columns="tableColumns"
          :el-table-props="tableProps"
          :pagination-props="$constants.table['pagination-props']"
          uniqueId="battery-details"
          :merge="{ startColumnNumber: 1, endColumnNumber: 2 }"
          :actionColumn="false"
          :sortMethodForColumns="sortMethodForColumns"
          type="white-header-table"
          class="battery-table"
          :key="$i18n.locale"
        >
          <template v-slot:title="{ row }">{{ row.data.title }}</template>
          <template v-slot:device_type="{ row }">
            {{ $t($constants.deviceTypes[row.data.device_type].lang_key) }}
          </template>
          <template v-slot:battery_voltage="{ row }">
            <span :style="generateColorForBatterVoltage(row.data)">
              {{ batteryVoltage(row.data) }}
            </span>
          </template>
          <template v-slot:time="{ row }">
            {{ lastCommunicationDate(row.data) }}
          </template>
          <template v-slot:status="{ row }">
            <span :style="generateColorForStatus(row.data)">
              {{ row.data.status === "ONLINE" ? $t("online") : $t("offline") }}
            </span>
          </template>
          <!-- <template slot="gutter">{{""}}</template> -->
        </er-data-tables>
      </el-row>
    </el-row>
  </layout-pondlogs>
</template>

<script>
import { mapGetters } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
const minDateISOStiring = "1970-01-01T00:00:00.000Z";
export default {
  name: "BatteryPage",
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      tableDataArr: [],
      search: "",
      loading: true,
      tableProps: {
        // border: true,
        size: "small",
        defaultSort: {
          prop: "pond_title",
          order: "ascending"
        }
      },
      filters: [
        {
          value: "",
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (
                ["device_type", "pond_title", "code", "title"].indexOf(prop) >
                -1
              ) {
                return row[prop]
                  .toLowerCase()
                  .includes(filter.value.toLowerCase());
              }
            });
          }
        }
      ]
    };
  },
  computed: {
    ...mapGetters("user", {
      getUserTimeZone: "getUserTimeZone",
      getUserTimeZoneOffset: "getUserTimeZoneOffset"
    }),
    getPonds() {
      return this.$store.getters["pond/getPondsObj"];
    },
    getCurrLocation() {
      return this.$store.getters["user/getCurrUserLocation"];
    },
    sortMethodForColumns: function() {
      return {
        pond_title: this.$commonUtils.alphaNumericComparator,
        title: this.$commonUtils.alphaNumericComparator
      };
    },
    tableColumns() {
      return {
        pond_title: {
          prop: "pond_title",
          label: this.$t("Comn_pond_name"),
          minWidth: "150",
          sortable: true,
          sortMethod: (a, b) =>
            this.$commonUtils.alphaNumericComparator(
              a.pond_title,
              b.pond_title
            ),
          align: "left"
        },
        device_type: {
          prop: "device_type",
          label: this.$t("Comn_device_type"),
          minWidth: "100",
          sortable: true
        },
        title: {
          prop: "title",
          label: this.$t("Comn_device_id"),
          minWidth: "100",
          sortable: true,
          sortMethod: this.$commonUtils.naturalSort("title")
        },
        battery_voltage: {
          prop: "battery_voltage",
          label: this.$t("Comn_voltage"),
          minWidth: "100",
          sortable: true
        },
        status: {
          prop: "status",
          label: this.$t("Status"),
          minWidth: "100",
          sortable: true
        },
        time: {
          prop: "date",
          label: this.$t("Comn_time"),
          minWidth: "160",
          sortable: "custom"
        }
      };
    },
    lastCommunicationDate() {
      return data => {
        if (
          data.last_communicated_at &&
          this.$moment(data.last_communicated_at).diff(
            this.$moment(minDateISOStiring)
          ) !== 0
        ) {
          return this.$moment(data.utc_last_communicated_at)
            .utcOffset(this.getUserTimeZoneOffset)
            .format("YYYY-MM-DD HH:mm:ss");
        } else {
          return "--";
        }
      };
    },
    batteryVoltage() {
      return data => {
        return !this.isNullOrUndefined(
          data.display_battery_voltage || data.battery_voltage
        )
          ? this.toFixedAndParseFloat(
              data.display_battery_voltage || data.battery_voltage
            )
          : "--";
      };
    },
    generateColorForBatterVoltage() {
      return data => {
        const bv = this.batteryVoltage(data);
        if (data.device_type === this.$constants.deviceTypes.POND_GUARD.key) {
          if (bv <= 3.3) {
            return { color: "Red" };
          } else if (bv > 3.3 && bv <= 3.7) {
            return { color: "Orange" };
          } else if (isNaN(bv)) {
            return { color: "Black" };
          } else {
            return { color: "Green" };
          }
        } else if (
          data.device_type === this.$constants.deviceTypes.POND_MOTHER.key ||
          data.device_type === this.$constants.deviceTypes.SHRIMP_TALK.key
        ) {
          if (bv <= 11) {
            return { color: "Red" };
          } else if (bv > 11 && bv <= 12) {
            return { color: "Orange" };
          } else if (isNaN(bv)) {
            return { color: "Black" };
          } else {
            return { color: "Green" };
          }
        }
      };
    },
    generateColorForStatus() {
      return data => {
        const deviceStatus = this.deviceStatus(data);
        return deviceStatus === "ONLINE"
          ? { color: "Green", "font-weight": 550 }
          : { color: "#bdbdbd", "font-weight": 550 };
      };
    },
    deviceStatus() {
      return data => {
        return data.comm_status ? "ONLINE" : "OFFLINE";
      };
    }
  },
  mounted() {
    this.initComponent();
  },
  methods: {
    handleSort({ column, prop, order }) {
      if (prop === "date") {
        this.tableDataArr.sort((a, b) => {
          const value1 = a.last_communicated_at;
          const value2 = b.last_communicated_at;
          if (order === "ascending") {
            return this.$moment(value1).diff(this.$moment(value2));
          } else if (order === "descending") {
            return this.$moment(value2).diff(this.$moment(value1));
          }
        });
      }
    },
    async initComponent() {
      this.loading = true;
      try {
        // let response1 = this.$store.
        const pondsdeviceSummary = await this.$store.dispatch(
          "pond/fetchPondsDeviceStatus",
          {
            location_id: this.getCurrLocation._id,
            get_all: true
          }
        );
        this.tableDataArr = pondsdeviceSummary.map(pond => {
          let pgData = pond.pond_guards.map(
            ({
              title,
              code,
              date,
              utc_date,
              sensor_values,
              utc_last_communicated_at,
              last_communicated_at,
              comm_status
            }) => {
              return {
                pond_title: pond.title,
                device_type: this.$constants.deviceTypes.POND_GUARD.key,
                battery_voltage: (sensor_values || { battery_voltage: 0 })
                  .battery_voltage,
                title,
                code,
                date: (sensor_values || { date: minDateISOStiring }).date,
                utc_date: (sensor_values || { utc_date: minDateISOStiring })
                  .utc_date,
                utc_last_communicated_at:
                  utc_last_communicated_at || minDateISOStiring,
                last_communicated_at: last_communicated_at || minDateISOStiring,
                comm_status
              };
            }
          );
          pgData = pgData.map(pg => {
            pg.status = this.deviceStatus(pg);
            return pg;
          });
          let pmData = pond.pond_mothers.map(
            ({
              code,
              title,
              sensor_values,
              utc_last_communicated_at,
              last_communicated_at,
              comm_status
            }) => {
              return {
                pond_title: pond.title,
                device_type: this.$constants.deviceTypes.POND_MOTHER.key,
                title,
                battery_voltage: (sensor_values || { battery_voltage: 0 })
                  .battery_voltage,
                display_battery_voltage: (
                  sensor_values || { display_battery_voltage: 0 }
                ).display_battery_voltage,
                code,
                date: (sensor_values || { date: minDateISOStiring }).date,
                utc_date: (sensor_values || { utc_date: minDateISOStiring })
                  .utc_date,
                utc_last_communicated_at:
                  utc_last_communicated_at || minDateISOStiring,
                last_communicated_at: last_communicated_at || minDateISOStiring,
                comm_status
              };
            }
          );
          pmData = pmData.map(pm => {
            pm.status = this.deviceStatus(pm);
            return pm;
          });
          let stData = pond.shrimp_talks.map(
            ({
              code,
              title,
              sensor_values,
              utc_last_communicated_at,
              last_communicated_at,
              comm_status
            }) => {
              return {
                pond_title: pond.title,
                device_type: this.$constants.deviceTypes.SHRIMP_TALK.key,
                battery_voltage: (sensor_values || { battery_voltage: 0 })
                  .battery_voltage,
                display_battery_voltage: (
                  sensor_values || { display_battery_voltage: 0 }
                ).display_battery_voltage,
                code,
                title,
                date: (sensor_values || { date: minDateISOStiring }).date,
                utc_date: (sensor_values || { utc_date: minDateISOStiring })
                  .utc_date,
                utc_last_communicated_at:
                  utc_last_communicated_at || minDateISOStiring,
                last_communicated_at: last_communicated_at || minDateISOStiring,
                comm_status
              };
            }
          );
          stData = stData.map(st => {
            st.status = this.deviceStatus(st);
            return st;
          });
          return [...pgData, ...pmData, ...stData];
        });
        this.tableDataArr = this.tableDataArr.flat(1);
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    isNullOrUndefined(variable) {
      if (variable === undefined || variable === null) {
        return true;
      }
      return false;
    },
    toFixedAndParseFloat(val) {
      return parseFloat(Number(val).toFixed(3));
    },
    batteryStatusBasedOnDate(deviceType, diff) {
      const inActiveTime = this.getTimeForInactive(deviceType);
      return diff < 0 || diff <= inActiveTime ? "ONLINE" : "OFFLINE";
    },
    getTimeForInactive(deviceType) {
      let time = 1800;
      switch (deviceType) {
        case this.$constants.deviceTypes.POND_MOTHER.key:
          time = 1800;
          break;
        case this.$constants.deviceTypes.POND_GUARD.key:
          time = 1800;
          break;
        case this.$constants.deviceTypes.SHRIMP_TALK.key:
          time = 900;
          break;
        default:
          time = 1800;
          break;
      }
      return time;
    }
  }
};
</script>

<style lang="scss">
.pond-device-status-table {
  $default-font-size: 13px;
  $font-color: #404243;
  h3 {
    font-weight: 600;
  }

  .battery-table {
    .pagination-bar {
      display: flex;
      justify-content: center;
    }

    // @media only screen and (max-width: 2560px) {
    //   .el-pagination__total {
    //     margin-right: 25%;
    //     // font-weight: 400;
    //     // color: #606266;
    //     margin-left: 1rem;
    //   }
    // }

    .el-pagination__total {
      margin-right: 0px;
      // font-weight: 400;
      // color: #606266;
      margin-left: 1rem;
    }

    // @media only screen and (max-width: 1660px) {
    //   .el-pagination__total {
    //     margin-right: 0px;
    //     // font-weight: 400;
    //     // color: #606266;
    //     margin-left: 1rem;
    //   }
    // }

    // @media only screen and (max-width: 1440px) {
    //   .el-pagination__total {
    //     margin-right: 6rem;
    //     // font-weight: 400;
    //     // color: #606266;
    //     margin-left: 1rem;
    //   }
    // }

    // @media only screen and (max-width: 1280px) {
    //   .el-pagination__total {
    //     margin-right: 4rem;
    //     // font-weight: 400;
    //     // color: #606266;
    //     margin-left: 1rem;
    //   }

    //   @media only screen and (max-width: 768px) {
    //     .el-pagination__total {
    //       margin-right: 8rem;
    //       // font-weight: 400;
    //       // color: #606266;
    //       margin-left: 1rem;
    //     }
    //   }
    // }
  }
  .refresh-icon {
    display: flex;
    justify-content: inherit;
    img {
      margin-left: 16px;
      width: 16px;
    }
  }
  .el-card__body {
    padding-top: 8px;
  }
  .row-1 {
    margin-top: 8px;
    margin-bottom: 16px;
    .el-card__header {
      border-bottom: 0px solid #ebeef5;
    }
    .search-bar-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 0.2rem;

      .search-bar {
        position: relative;
        padding-right: 4px;
        margin-left: 12px;
        width: 180px;
        input {
          background: #f2f3f4;
          border: 0px solid #dcdfe6;
          border-radius: 8px;
          color: black !important;
          width: 180px;
        }
        img {
          width: 16px;
          position: absolute;
          bottom: 0;
          right: 0;
          margin: 6px;
        }
        .el-input--small .el-input__inner {
          height: 28px;
          line-height: 28px;
        }
      }
    }
  }
  .el-table__header th {
    .cell {
      font-weight: bold;
    }
  }
  .el-table {
    border-radius: 10px;
    box-shadow: 0px 1px 6px #00000029;

    .el-table__body-wrapper {
      min-height: 60vh;
    }
    .cell {
      text-align: center;
      font-size: $default-font-size;
      .el-tag {
        font-size: $default-font-size;
      }
    }
    .el-table__header {
      tr {
        background-color: #44a1ff;
        color: white;
      }
      th {
        background-color: transparent;
        &:nth-last-child(2) {
          .cell {
            border-right: none;
          }
        }
        & > .cell {
          display: inline-block;
          -webkit-box-sizing: border-box;
          border-right: 1px solid white;
          box-sizing: border-box;
          position: relative;
          vertical-align: middle;
          padding-left: 10px;
          padding-right: 10px;
          width: 100%;
          height: 32px;
          line-height: 32px;
        }
        // .sort-caret {
        //   &.ascending {
        //     border-bottom-color: transparent;
        //   }
        //   &.descending {
        //     border-top-color: transparent;
        //   }
        // }
      }
    }
  }
  .is-sortable {
    &.ascending .sort-caret.ascending {
      border-bottom-color: #ffffff;
    }
    &.descending .sort-caret.descending {
      border-top-color: #ffffff;
    }
  }
  .el-pagination {
    margin-top: 20px;
    vertical-align: middle;
    .el-pagination__sizes {
      .el-input--mini {
        .el-input__icon {
          line-height: 22px;
        }
        .el-input__inner {
          height: 22px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
